module.exports = __webpack_public_path__ + "static/logo-540358c9d0c215a4656decb9b724db61.png";